/**
* description:
* File of container Panel Container
*
* data : 2017-09-01
*/

import Vue from 'vue';
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';

// COMPONENTS //////////////////////////////////////////////////////////////////
import LoadingOverlay from '@/components/Common/LoadingOverlay';
import HeaderContainer from '@/components/Panel/HeaderContainer';
import HeaderLogo from '@/components/Panel/HeaderContainer/HeaderLogo';
import HeaderMain from '@/components/Panel/HeaderContainer/HeaderMain';
import HeaderNav from '@/components/Panel/HeaderContainer/HeaderNav';
import PanelContent from '@/components/Panel/PanelContent';
import Modal from '@/components/Common/Modal';

// CONTAINER ///////////////////////////////////////////////////////////////////
const Panel = {
  components: {
    LoadingOverlay,
    HeaderContainer,
    HeaderLogo,
    HeaderMain,
    HeaderNav,
    PanelContent,
    Modal,
  },
  store,

  computed: {
    ...mapGetters(['isMenuExpanded', 'user', 'isAuthenticated', 'loginLoading', 'modal']),
  },

  async created() {
    await this.getGlobalDictionary();
  },

  methods: {
    ...mapActions(['getGlobalDictionary']),
  },

  template: `
    <div class="my-container">
      <Modal v-if="modal.isVisible" :modal="modal" />
      <el-row>
        <loading-overlay v-if="loginLoading" />
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <header-container>
            <header-logo slot="header-logo" />
            <header-main slot="header-main" :login-loading="loginLoading" />
            <header-nav slot="header-nav" />
          </header-container>
        </el-col>
      </el-row>      
      <el-row class="el-row--full">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" class="el-col--full">
          <panel-content />
        </el-col>
      </el-row>
    </div>
  `,
};

export default Vue
  .component('Panel', Panel);



// WEBPACK FOOTER //
// ./src/containers/Panel/index.js